import React from 'react';
import PropTypes from 'prop-types';
import PriceLine from '../price-line';

const x = d => new Date(d.date);
const y = d => d.lowestPrice;

const PriceHistoryCurve = ({ margin, xScale, yScale, data }) => (
  <PriceLine
    margin={margin}
    xScale={xScale}
    yScale={yScale}
    color="#4895B6"
    data={data}
    x={x}
    y={y}
  />
);

PriceHistoryCurve.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      lowestPrice: PropTypes.number,
    })
  ).isRequired,
  margin: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }).isRequired,
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired,
};

export default PriceHistoryCurve;
